module.exports = __webpack_public_path__ + "static/media/point_infoActive.a747c0d5.png";